
import React from 'react';

import menuPdf from './img/menuPdf.pdf'
import logo from './img/home.png';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';



function MenuPdf() {
  const ColorButton = styled(Button)(({ theme }) => ({
    fontSize: "100%",
    marginBottom: "10%",
    top: 20,
    color: "#fff",
    backgroundColor: "rgb(21 50 76)",
    '&:hover': {
      backgroundColor: "rgb(21 50 76)",
    },
  }));
  return (
    <React.Fragment key={3}>
      <div className="Content">
        <img src={logo} alt="home" className="menu" />
        <ColorButton href={menuPdf} variant="contained" className="buttonCaffePdf">Apri il menù</ColorButton>
      </div>
    </React.Fragment>
  )
}
export default MenuPdf;